import React from "react";

export default function TextField({ attachedFile, ...props }) {
  const tracksAttachment = attachedFile !== undefined;
  const hasAttachment =
    (typeof File !== "undefined" && attachedFile instanceof File) ||
    (typeof attachedFile === "string" && attachedFile.trim() !== "");
  const fileName = tracksAttachment
    ? hasAttachment
      ? typeof attachedFile === "string" ? attachedFile.split("/").pop() : attachedFile.name
      : ""
    : props.fileName;
  // Browsers clear native file inputs when a form step remounts. The retained
  // File in React state is still submitted, so it satisfies the requirement.
  const inputRequired = props.required && !(props.type === "file" && hasAttachment);
  return (
    <div
      className={`${
        props.view === "straight" ? "d-flex align-items-center " : ""
      }`}
    >
      {props?.label && (
        <label
          className={` mt-2
            ${
              props?.error
                ? "form-label-error  control-label "
                : "control-label mylabel "
            } 
            ${props.view === "straight" ? "col-3 " : ""}
            `}
          htmlFor={props.id}
        >
          {props?.label}
          {props.required && <span className="required-asterisk">*</span>}
        </label>
      )}

      <div
        className={`${
          props.required
            ? props.fileHeightAdjust
              ? "mandatory input-group mb-2"
              : "mandatory input-group"
            : props.fileHeightAdjust
            ? "input-group"
            : "input-group mb-2"
        } `}
      >
        {props.multiline ? (
          <textarea
            {...props}
            autoComplete="off"
            maxLength={props.maxLength}
            className={
              props.error
                ? `form-control errorinput textareastyle mb-2`
                : ` form-control textareastyle mb-2`
            }
          />
        ) : props.type === "file" && fileName ? (
          <div
            className={`${
              props.fileHeightAdjust
                ? "upload-field-head mb-2"
                : "upload-field mb-2"
            }`}
          >
            <label
              htmlFor={props.id}
              className={props.required ? `errorfile` : ``}
            >
              <input
                {...props}
                required={inputRequired}
                autoComplete="off"
                className={
                  props.error
                    ? props.fileHeightAdjust
                      ? ` form-control errorinput h-6`
                      : ` form-control errorinput mb-2`
                    : props.fileHeightAdjust
                    ? ` form-control h-6`
                    : "form-control mb-2"
                }
              />
              <span className="file-name">
                {fileName?.split("/").pop()}
              </span>
            </label>
          </div>
        ) : (
          <input
            {...props}
            required={inputRequired}
            autoComplete="off"
            accept={props.accept}
            className={
              props.error
                ? props.fileHeightAdjust
                  ? ` form-control errorinput`
                  : ` form-control errorinput mb-2`
                : props.fileHeightAdjust
                ? ` form-control mb-2`
                : ` form-control mb-2`
            }
          />
        )}
      </div>
    </div>
  );
}
